import encryptServer from '../request/encryptRequest';

// 银行列表
export const queryBankPage = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/base/queryBankPage', params);

// 银行支行列表
export const queryOpeningBankPage = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/base/queryOpeningBankPage', params);
